import * as React from "react";
import ProgressiveImage from "react-progressive-image";
import { CSSTransition } from "react-transition-group";
import defaultImagem from "common/assets/images/thumb-default.png";
import { StyleSheet, css } from "aphrodite";

type IProps = {
  imageUrl: string;
};

const styles = StyleSheet.create({
  imgHigh: {
    top: "-100%",
    left: 0,
    right: 0,
    bottom: "-100%",
    margin: "auto",
    width: "100%",
  },
  imgLong: {
    left: "-100%",
    top: 0,
    bottom: 0,
    right: "-100%",
    margin: "auto",
    height: "100%",
  },
  container: {
    height: "125px",
    width: "100%",
    overflow: "hidden",
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
});

class CardGridImage extends React.Component<IProps> {
  constructor(props) {
    super(props);
    this.setClassName = this.setClassName.bind(this);
  }
  setClassName(node: any) {
    if (node) {
      if (node.clientWidth / node.clientHeight > 1.84)
        node.className = css(styles.imgLong);
      else node.className = css(styles.imgHigh);
    }
  }
  render() {
    const { imageUrl } = this.props;
    let imageURL = imageUrl ? imageUrl : defaultImagem;
    return (
      <div className={css(styles.container)} style={{ position: "relative" }}>
        <ProgressiveImage src={imageURL} placeholder="tiny-image.jpg">
          {(src, loading) => (
            <CSSTransition
              in={!loading}
              enter={true}
              exit={true}
              timeout={300}
              classNames={{
                enter: css(styles.transitionEnter),
                enterActive: css(styles.transitionEnterActive),
                exit: css(styles.transitionLeave),
                exitActive: css(styles.transitionLeaveActive),
              }}
              unmountOnExit
            >
              <img
                src={src}
                ref={this.setClassName}
                style={{ position: "absolute" }}
              />
            </CSSTransition>
          )}
        </ProgressiveImage>
      </div>
    );
  }
}

export default CardGridImage;



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/CardGridImage.tsx